// ExportCVTDialog.tsx — Export current project as a reusable .cvt template

import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import { exportTemplateCVT } from '../utils/cvpFormat';

export default function ExportCVTDialog() {
  const project = useShallowStore(s => s.project);

  return (
    <DialogBase
      title="Export Template (.cvt)"
      okLabel="Export"
      onOk={() => project && exportTemplateCVT(project)}
    >
      {project ? (
        <>
          <p className="dialog-info">
            Exporting <strong>{project.name}</strong> as a reusable template.
          </p>
          <p className="dialog-info">
            {project.panels.length} panel archetype(s) · project settings
          </p>
          <p className="dialog-info">
            The following fields are <strong>stripped</strong> from the template:
            job number, client, engineer, drawing dates, drawn-by initials, and notes.
            Panel geometry and all design settings are preserved.
          </p>
          <p className="dialog-info">
            When imported, a new project is created with blank job info ready to fill in.
          </p>
        </>
      ) : (
        <p className="dialog-warning">No project open. Please open or create a project first.</p>
      )}
    </DialogBase>
  );
}
